import { ENV_CONFIG } from '../utils/env.js';

// API Configuration
export const API_BASE_URL = ENV_CONFIG.API_URL;

// Debug logging
// console.log('🔧 Environment Configuration:', ENV_CONFIG);
// console.log('🌐 API_BASE_URL set to:', API_BASE_URL);
export const API_ENDPOINTS = {
  USERS: {
    REGISTER: '/api/users/register',
    SPIN: '/api/users/spin',
    SPIN_STATUS: '/api/users/spin-status',
  },
  PRIZES: {
    LIST: '/api/prizes', // All prizes
    AVAILABLE: '/api/prizes/available', // Only available prizes
    SEED: '/api/prizes/seed',
  },
};

// Recruitment Configuration
export const RECRUITMENT_CONFIG = {
  FORM_URL: 'https://juniorisep.quillforms.app/forms/recrutement-cdp-2026-2027',
};

// Wheel Configuration
export const WHEEL_CONFIG = {
  MIN_SPINS: 5,
  MAX_SPINS: 10,
  SPIN_DURATION: 3000, // milliseconds
  WHEEL_SIZE: 320, // pixels
  WHEEL_RADIUS: 140, // pixels (center - 20)
  CENTER_MARGIN: 20, // pixels
};

// Animation Configuration
export const ANIMATION_CONFIG = {
  TRANSITION_DURATION: 300, // milliseconds
  HOVER_SCALE: 1.05,
  PULSE_ANIMATION: 'animate-pulse',
};

// UI Configuration
export const UI_CONFIG = {
  BUTTON_HEIGHT: 'h-14',
  BUTTON_WIDTH: 'w-14',
  LOGO_SIZE: {
    SMALL: 'w-20 h-20',
    MEDIUM: 'w-40 h-40',
  },
};

// Error Messages
export const ERROR_MESSAGES = {
  REGISTRATION_FAILED: 'Erreur lors de l\'inscription',
  PRIZES_FETCH_FAILED: 'Erreur lors de la récupération des prix',
  SPIN_STATUS_CHECK_FAILED: 'Erreur lors de la vérification du statut',
  SPIN_RECORDING_FAILED: 'Erreur lors de l\'enregistrement du spin',
};
